import { Button, Card, CardContent, Typography } from '@eye-able/ui';
import { RotateCcw } from 'lucide-react';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { T } from '@/i18n/T';

function FilteredIssuesPlaceholder({
  onResetFilters,
}: {
  onResetFilters: () => void;
}) {
  const { t } = useInlineTranslation();
  return (
    <Card>
      <CardContent className='eye:flex eye:flex-col eye:items-start eye:gap-xs eye:p-s'>
        <Typography className='eye:text-grey-120'>
          <T k='noFilteredIssues' />
        </Typography>
        <Button variant='outline' size='sm' onClick={onResetFilters}>
          <RotateCcw aria-hidden />
          {t('resetFilters')}
        </Button>
      </CardContent>
    </Card>
  );
}

export { FilteredIssuesPlaceholder };
